import React from 'react';

import { IconElement } from './icon.styled';
import { Icons } from './svgs';

const DEFAULT_ICON_SIZE = '20px';

export const Icon = ({ type, fill, size = DEFAULT_ICON_SIZE }) => {
  const SelectedIcon = Icons[type];

  if (!SelectedIcon) {
    console.error(`Icon with type ${type} does not exist!`);
    return null;
  }

  return <IconElement as={SelectedIcon} $size={size} $fill={fill} />;
};

export default Icon;
